// Pages Without Layout
import Success from 'pages/success'

// Public Pages
import Offer from 'pages/offers/offer'
import Offers from 'pages/offers/offer-list'
import Subjects from 'pages/subjects'
import Courses from 'pages/courses'
import CourseDetail from 'pages/course-detail'
import Summary from 'pages/summary'

// Parent Pages
import Home from 'pages/home/dashboard'
import Support from 'pages/home/support'
import Packages from 'pages/home/packages/package-list'
import Package from 'pages/home/packages/package'
import Users from './home/users'
import NewUser from './home/users/NewUser'
import Payment from './home/payment'
import PaymentHistory from './home/payment/history'
import Profile from './home/profile'
import UserPackages from './home/users/Packages'
import { wrapParentContainer, wrapAdminContainer, wrapAccountingContainer } from 'layout/containers'

// AdminPages

import AdminHome from 'pages/admin/dashboard'
import OffersPage from './admin/offers'
import OfferConfigurationPage from './admin/offers/Configuration'
import ClientsPage from './admin/clients'
import ClientPage from './admin/client'

// AccountingPages
//
import AccountingHome from 'pages/accounting/dashboard'
import AccountingPayouts from 'pages/accounting/payouts'
import AccountingPayout from 'pages/accounting/payout'


const pages = {
    Offer,
    Offers,
    Subjects,
    Courses,
    CourseDetail,
    Summary,
    Success,
    Profile: wrapParentContainer('Profile', Profile),
    Home: wrapParentContainer('Home', Home),
    Support: wrapParentContainer('Home', Support),
    Packages: wrapParentContainer('Home', Packages),
    Package: wrapParentContainer('Package', Package),
    Users: wrapParentContainer('Users', Users),
    NewUser: wrapParentContainer('NewUser', NewUser),
    UserPackages: wrapParentContainer('UserPackage', UserPackages),
    Payment: wrapParentContainer('Payment', Payment),
    PaymentHistory: wrapParentContainer('PaymentHistory', PaymentHistory)
}

const adminPages = {
    Home: wrapAdminContainer('Home', AdminHome),
    Offers: wrapAdminContainer('Offers', OffersPage),
    OfferConfiguration: wrapAdminContainer('OfferConfiguration', OfferConfigurationPage),
    Clients: wrapAdminContainer('Clients', ClientsPage),
    Client: wrapAdminContainer('Client', ClientPage)
}

const accountingPages = {
    Home: wrapAccountingContainer('Home', AccountingHome),
    Payouts: wrapAccountingContainer('Payouts', AccountingPayouts),
    Payout: wrapAccountingContainer('Payout', AccountingPayout),
    Clients: wrapAdminContainer('Clients', ClientsPage),
    Client: wrapAdminContainer('Client', ClientPage)
}

type PageName = keyof typeof pages
type AdminPageName = keyof typeof adminPages
type AccountingPageName = keyof typeof accountingPages

export function Page(name: PageName) {
    return pages[name]
}

export function AdminPage(name: AdminPageName) {
    return adminPages[name]
}

export function AccountingPage(name: AccountingPageName) {
    return accountingPages[name]
}